import {MENU_ELEMENT_ID} from "./common/constants";
import {handleScroll} from "./scroll/scroll";
import {handleLogin} from "./auth/login";
import {handleMegamenu} from "./megamenu/megamenu";
import {hideMobileCategories, showMobileCategories} from "./api/toggleCategories";
import {onClientHeight} from "./common/clientHeight";
import {initializeOptimizelyClientInstance} from "./optimizely/optimizely";


const init = () => {

    /*
     * Menu is initially positioned as a block element to avoid CLS on page load.
     * When the page is loaded, we position the menu as a fixed and also add
     * top padding to the body equal to the menu height.
     */

    const $menu = document.getElementById(MENU_ELEMENT_ID);

    onClientHeight($menu)
        .then((menuHeight) => {
            $menu?.classList.add('tv2-menu--fixed');
            document.body.style.paddingTop = menuHeight + 'px';

            if (document.documentElement.dataset.menuHideOnScroll !== 'false') {
                handleScroll();
            }

            handleMegamenu();
            handleLogin();

            /*
             * Client side api for menu customizations (e.g. show/hide categories on mobile) will be handled
             * through custom events with the tv2-menu namespace/prefix.
             */
            document.addEventListener('tv2-menu:show-mobile-categories', showMobileCategories);
            document.addEventListener('tv2-menu:hide-mobile-categories', hideMobileCategories);

            /*
             * Let the world know that the menu is ready.
             */
            document.dispatchEvent(new CustomEvent('tv2-menu:ready', {detail: {$el: $menu}}));

            /**
             * Initialize Optimizely client
             */
            initializeOptimizelyClientInstance();
        });
}

if (document.readyState === 'complete') {
    init()
} else {
    document.addEventListener('DOMContentLoaded', init)
}
